<section id="modal">
  <div id="myModal" class="modal">

    <!-- Modal content -->
    <div class="modal-content">
      <span class="close" id="close_btn" on:click={handleClick}>&times;</span>
      <p>
        <br/>
        <span class="frnds"><strong>Dear Friends,</strong></span>
        <br/>
        <br/>

        <strong>NIT Trichy</strong> is organizing <strong>ICAMAT 2022</strong>  in association with NTNU Norway and TalTech, Estonia.   We have recently received requests from several authors to extend the conference dates and full paper submission dates. Also, based on suggestions from local authorites, the conference dates are revised to <strong>June 10-11, 2022.</strong> Full paper submission deadline and registration deadline is extended to <strong>31st May 2022.</strong>

        <br/>
        <br/>
        The inconvenience, if any,  is highly regretted.

        <br/>
        <br/>
        We are looking for meeting you all in June 2022 (either in person or online).

        <br/>
        <br/>
        With very best wishes

        <br/>
        <strong>The Organising Committee, ICAMAT 2022</strong>
      </p>
    </div>

  </div>
</section>

<script>
// Get the modal

// Get the <span> element that closes the modal
// var span = document.getElementById("close_btn");

// // When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modal.style.display = "none";
// }

// When the user clicks anywhere outside of the modal, close it

function handleClick() {
  modal.style.display = "none";
}
window.onclick = function(event) {
  var modal = document.getElementById("myModal");

  if (event.target == modal) {
    modal.style.display = "none";
  }
}
</script>

<style>
body {font-family: Arial, Helvetica, sans-serif;}

/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 186px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* The Close Button */
.close {
  position: absolute;
  right: 16px;
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
p {
  font-size: 18px
}

.frnds {
  color: orange;
  font-size: 22px;
}
</style>
